import React from 'react';
import {Tabs} from 'antd';
import EnumManageList from './enumManageList';
import EnumManageDetails from './enumManageDetails.js';

const { TabPane } = Tabs;
class EnumManage extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        isfalse:null,
        params:null
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.isfalse=true;
            this.state.params = params
          }
          if(type == "add"){
            this.state.isfalse=false;
            this.state.params = null
          }
        this.setState({activeKey:activeKey})
      }
    render(){
        return(
          <div>
            <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="枚列举值表" key="1">
              <EnumManageList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
            </TabPane>
            <TabPane tab="枚列举详情" key="2">
              <EnumManageDetails  buttonList={this.props.buttonList} isfalse={this.state.isfalse} params = {this.state.params} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs>
          </div>
        )
    }
}
export default EnumManage;